<template>
  <div class="choose-id">
    <div class="content">
      <div class="text">{{ $t('choose_id_explain') }}</div>
      <div class="service-card">
        <div class="pic1"></div>
        <span class="text1">{{ $t('servicer') }}</span>
        <span id="text2" :title="$t('service_explain')" class="text-style text2">{{ $t('service_explain') }}</span>
        <el-load-icon class="loading-icon" v-if="loading === true"></el-load-icon>
        <el-button v-else @click="chooseId('register')" :max-width="maxWidth" class="button-style" type="primary">
          {{ $t('i_am_service') }}
        </el-button>
      </div>
      <div class="service-card margin-top" v-if="getCountryOrRegionIndex() !== 23">
        <div class="pic2"></div>
        <span class="text1">{{ $t('account_type_4') }}</span>
        <span id="text2_1" :title="$t('account_type_4_explain')" class="text-style text2">
          {{ $t('account_type_4_explain') }}
        </span>
        <el-load-icon class="loading-icon" v-if="loading === true"></el-load-icon>
        <el-button v-else @click="chooseId('endUserId')" :max-width="maxWidth" class="button-style" type="primary">
          {{ $t('i_am_account_type_4') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isAccountNeedUpgrade } from '@pro/common/dao/upgrade-strategy.js';

export default {
  data() {
    return {
      maxWidth: 320,
      loading: false
    };
  },
  mounted() {
    this.$bury.identityPageShow();
    if (process.env.appmode === 'NEUTRAL') {
      // 中性走默认选择
      this.chooseId('register');
    }
    this.getCountryOrRegionIndex() === 23 && this.chooseId('register');
  },
  methods: {
    async chooseId(type) {
      this.loading = true;
      if (type === 'register') {
        this.$bury.identityPageChoose(1);
        localStorage.removeItem('chooseType');
      } else if (type === 'endUserId') {
        this.$bury.identityPageChoose(2);
        localStorage.setItem('chooseType', 'endUserId');
      }
      // 检测使用onehikid注册还是使用hpc注册
      const upgradeStrategy = isAccountNeedUpgrade(this.getCountryOrRegionIndex());
      if (upgradeStrategy > 0) {
        this.$bury.OHIToOnehikid();
        this.loading = false;
        this.$emit('go-register', 'onehikid');
      } else {
        this.loading = false;
        this.$emit('go-register', 'hpc');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.choose-id {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  .content {
    .text {
      opacity: 0.7;
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      width: 400px;
      margin-bottom: 16px;
    }
    margin: 0 auto;
    .service-card {
      height: 211px;
      width: 380px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      margin-left: 10px;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      &:hover {
        box-shadow: 0 0 16px 0 rgba(0, 43, 122, 0.2);
      }
      .pic1 {
        margin-top: 8px;
        width: 60px;
        height: 60px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url('../../img/icon_select_installer_s.svg');
      }
      .pic2 {
        margin-top: 8px;
        width: 60px;
        height: 60px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url('../../img/icon_select_terminal.svg');
      }
      .loading-icon {
        margin-top: 23px;
      }
    }
  }
}
.margin-top {
  margin-top: 24px;
  margin-bottom: 24px;
}
.text1 {
  font-size: 14px;
  color: #000000;
  margin-top: 6px;
  text-align: center;
}
.text2 {
  max-height: 48px;
  opacity: 0.7;
  font-size: 12px;
  color: #000000;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.text-style {
  width: 375px;
  word-wrap: break-word;
  white-space: normal;
}
.button-style {
  margin-top: 23px;
  width: 320px;
  height: 32px;
}
</style>
